import { MouseEvent } from 'react'
import { useTranslation } from 'react-i18next'
import { IconButton } from 'rsuite'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEllipsisVertical } from '@fortawesome/free-solid-svg-icons'
import { useLayout, TContextMenuItem } from '@client/components/Layout/LayoutManager'

/**
 * The "⋮" beside the add button of a list in the sidebar: a menu for the
 * list's options, such as showing the archive (operator, 15.10.2026: "ein drei
 * Punkte Icon verwenden und beim Klick ein Contextmenü anzeigen. Da können wir
 * diese Dinge unterbringen.", and then "das 3 vertikalen Punkte Icon").
 */
export default function ListMenu({ items }: { items: TContextMenuItem[] }) {
    const { t } = useTranslation()
    const { onContextMenu } = useLayout()

    const open = (event: MouseEvent<HTMLElement>) => {
        // under the button, not where the click was
        const rect = event.currentTarget.getBoundingClientRect()
        onContextMenu(event, items, { id: '', label: '' }, { x: rect.left + window.scrollX, y: rect.bottom + window.scrollY })
    }

    return (
        <IconButton
            className="list-menu"
            appearance="subtle"
            size="sm"
            icon={<FontAwesomeIcon icon={faEllipsisVertical} />}
            title={t('More options')}
            aria-label={t('More options')}
            aria-haspopup="menu"
            onClick={open}
        />
    )
}
